
import {debounceTime} from 'rxjs/operators';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../../core/services/lms-logger.service';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { MessageDetails } from '../../../core/model/message-details.model';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { QueryViewLocoData } from '../../shared/model/query-view-locomotive-data.model';
import { QueryViewService } from '../../shared/services/query-view.service';
import { Router } from '@angular/router';
import { TabSearchParameter } from '../../../core/model/tab-search-parameter.model';
import { TabService } from '../../../core/services/tab.service';
import { TrainData } from '../../../core/model/train-data.model';
import { environment } from './../../../../environments/environment';

/**
 * @export
 * @class QueryViewLocoDataComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 * @implements {OnChanges}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-query-view-loco-data',
  templateUrl: './query-view-loco-data.component.html',
  styleUrls: ['./query-view-loco-data.component.scss']
})
export class QueryViewLocoDataComponent implements OnInit, OnChanges, OnDestroy {
  configData;
  @Input() loadData;
  loadDataToShow: Array<QueryViewLocoData>;
  header = '';
  currentDateTime = new Date().getTime();
  totalRecords: number;
  loadingStatus = false;
  isHistorySorted = false;
  isHeaderAdjusted = false;
  upperHeight = 245;
  @Output() showLocoMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  scrollWidthLocoTable = (window.innerWidth - 70) + 'px';
  scrollHeightLocoTable = (window.innerWidth - this.upperHeight) + 'px';
  locoLinks: Array<MenuItem>;
  trainLinks: Array<MenuItem>;
  overlayLinks: Array<MenuItem>;
  overlayPanel: OverlayPanel;
  panelVisible = false;
  contextType: string;
  contextSearchText: string;
  currentContextLoco;
  overlayLocateLocoData;
  @Output() hideContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('dt', { static: true }) locoDataTable;

  constructor(private configService: ConfigService,
    private router: Router, private lmsRendererService: LmsRendererService,
    private queryViewService: QueryViewService,
    private appUtilService: AppUtilityService, private lmsLoaderService: LmsLoaderService,
    private lmsLoggerService: LmsLoggerService, private appUtilityService: AppUtilityService,
    private messageHandlerService: MessageHandlerService, private tabService: TabService) {
    this.configData = this.configService.getConfigData();
    this.loadDataToShow = [];
    this.locoLinks = [];
    const rowCount = this.appUtilityService.getRowPerPageCount(26, 245);
    this.trainLinks = [];
    this.locoLinks.push({ label: 'Data' });
    this.locoLinks.push({ label: 'History' });
    this.locoLinks.push({ label: 'Notes' });
    this.locoLinks.push({ label: 'Locate' });

    this.trainLinks.push({ label: 'Data' });
    this.trainLinks.push({ label: 'Profile' });
    this.trainLinks.push({ label: 'History' });
    this.trainLinks.push({ label: 'Notes' });
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
        this.prepareHeightForPage();
        this.prepareDataList();
      }
    });
  }

  /**
   * This method is used to close the context panel
   * of train or locomotive
   * @memberOf LmsTerminalBoundComponent
   */
  public hideLocoTrainContextPanel() {
    this.hideContextMenu.emit(true);
  }

  /**
   * every time when input changes and before nginit it fire
   * @memberof QueryViewLocoDataComponent
   */
  ngOnChanges() {
    if (this.loadData && this.loadData.data && this.loadData.data.length > 0) {
      this.prepareDataList();
    } else {
      this.loadDataToShow = [];
      this.totalRecords = 0;
    }
  }

  /**
   * how manyb record are come set in this method
   * @private
   * @memberof QueryViewLocoDataComponent
   */
  private prepareDataList() {
    this.totalRecords = this.loadData.data.length;
  }


  /**
   * @param {string} type
   * @memberof QueryViewLocoDataComponent
   */
  setOverlayLinks(type: string, data?: any) {
    this.checkForOverlayPanelVisibility();
    this.overlayLocateLocoData = null;
    if (type === 'loco') {
      if (data) {
        this.overlayLocateLocoData = data;
      }
      this.overlayLinks = this.locoLinks;
    } else if (type === 'train') {
      this.overlayLinks = this.trainLinks;
    }
  }

  /**
   * @param {any} event
   * @param {OverlayPanel} panel
   * @param {QueryViewLocoData} alert
   * @param {string} obj
   * @returns
   * @memberof QueryViewLocoDataComponent
   */
  public locomotiveOverlayPosition(event, panel: OverlayPanel, alert: QueryViewLocoData, obj: string) {
    this.overlayPanel = panel;
    if (!panel.overlayVisible && this.panelVisible === true) {
      this.panelVisible = false;
    }
    if (this.panelVisible) {
      panel.hide();
      this.panelVisible = false;
      event.stopPropagation();
      return;
    }
    const overlayPanel = document.getElementById('overlayLinksInfo').getElementsByClassName('p-overlaypanel');
    let element;
    if (obj === 'loco') {
      element = document.getElementById('locomotive' + alert.locomotiveId).parentElement;
      this.contextType = 'Locomotive';
      this.contextSearchText = alert.locomotiveId;
    } else if (obj === 'train') {
      element = document.getElementById('train' + alert.lmsLocation).parentElement;
      this.contextType = 'Train';
      this.contextSearchText = alert.lmsLocation;
    }
    panel.show(event);
    const rect = element.getBoundingClientRect();
    const scrollHeight = window.pageYOffset;
    const windowHeight = window.innerHeight;
    let overlayHeight = 0;
    if (this.overlayLinks && this.overlayLinks.length > 0) {
      overlayHeight = this.overlayLinks.length * 30;
    } else {
      panel.hide();
      return;
    }
    let top;
    if ((windowHeight - rect.top - rect.height) > overlayHeight) {
      top = rect.top + rect.height + scrollHeight + 'px';
    } else {
      top = (rect.top - overlayHeight) + scrollHeight + 'px';
    }
    const left = rect.left + 'px';
    const width = rect.width + 'px';
    let style = `display: block; z-index: 1001; visibility: visible; 
            opacity: 1.032; top: <<top>>; left: <<left>>; width: <<width>>;`;
    style = style.replace('<<top>>', top);
    style = style.replace('<<left>>', left);
    style = style.replace('<<width>>', width);
    overlayPanel[0].setAttribute('style', style);
    event.stopPropagation();
    this.panelVisible = true;
    this.currentContextLoco = alert;
  }

  /**
   * @param {any} event
   * @param {OverlayPanel} panel
   * @returns
   * @memberof QueryViewLocoDataComponent
   */
  public hideOverlayPanel(event, panel: OverlayPanel) {
    this.checkForOverlayPanelVisibility();
    if (this.panelVisible) {
      panel.hide();
      this.panelVisible = false;
      panel = null;
      this.currentContextLoco = null;
      return;
    }
  }

  /**
   * @param {any} event
   * @memberof QueryViewLocoDataComponent
   */
  @HostListener('document:click') hideAddTabPanel(event) {
    this.checkForOverlayPanelVisibility();
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  /**
   * @memberof QueryViewLocoDataComponent
   */
  checkForOverlayPanelVisibility() {
    if (this.overlayPanel) {
      this.overlayPanel.hide();
      this.currentContextLoco = null;
      this.overlayPanel = null;
      this.contextType = null;
      this.contextSearchText = null;
      this.overlayLinks = null;
    }
  }
  /**
   * this method set height of page according to page size
   * @memberof QueryViewLocoDataComponent
   */
  prepareHeightForPage() {
    const windowHeight = this.lmsRendererService.getWindowHeight();
    const windowWidth = this.lmsRendererService.getWindowWidth();
    if (windowWidth && windowWidth < 1280) {
      this.scrollHeightLocoTable = (windowHeight - 260) + 'px';
      this.scrollWidthLocoTable = windowWidth - 70 + 'px';
    } else {
      this.scrollHeightLocoTable = (windowHeight - this.upperHeight - 30) + 'px';
      this.scrollWidthLocoTable = windowWidth - 70 + 'px';
    }
  }

  /**
   * get on which table datatable  created
   * @returns
   * @memberof QueryViewLocoDataComponent
   */
  getTableElement() {
    const locoDataTable = document.getElementById('queryViewLocoMotiveResults');
    if (locoDataTable && locoDataTable.children[0] && locoDataTable.children[0].children[0] && locoDataTable.children[0].children[0].children[0]) {
      return locoDataTable.children[0].children[0].children[0];
    }
    return null;
  }

  /**
  * This shows Locomotive Context Menu
  * @param {TrainData} train
  * @param {LocoDetail} loco
  * @memberOf LmsTerminalBoundComponent
  */
  public showLocomotiveContextMenu(train: TrainData, loco, index: string) {
    if (this.isContextMenuAvailable(loco)) {
      const locoMenu = new Map<string, any>();
      if (loco.locomotiveId && loco.locomotiveId.length > 5) {
        locoMenu.set('locoData', loco);
        locoMenu.set('trainId', 'train' + train.trainIdentifier);
        locoMenu.set('index', index);
        locoMenu.set('header', this.header);
        this.showLocoMenu.emit(locoMenu);
      }
    }
  }

  /**
   * route to terminal
   * @param {any} TerminalMnemonic
   * @memberof QueryViewLocoDataComponent
   */
  goToTerminal(TerminalMnemonic) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: TerminalMnemonic });
    
    window.open(
      window.location.href.split('?')[0] + '?type=terminal&subtype=status&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
   * route to loco
   * @param {any} LocoMnemonic
   * @memberof QueryViewLocoDataComponent
   */
  goToLoco(LocoMnemonic) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: this.appUtilityService.UIformatLocomotiveId(LocoMnemonic) });
      window.open(
        window.location.href.split('?')[0] + '?type=locomotive&subtype=data&search=' + tabSearchParameter.searchText,
        '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
      );
  }

  /**
   * check that this is train or not
   * @param {any} mnemonic
   * @returns
   * @memberof QueryViewLocoDataComponent
   */
  isTrain(mnemonic) {
    return this.appUtilService.isValidTrainId(mnemonic);
  }

  /**
   * route to respective terminal
   * @param {any} mnemonic
   * @memberof QueryViewLocoDataComponent
   */
  goToTrainTerminal(mnemonic) {
    if (this.appUtilService.isValidTrainId(mnemonic)) {
      this.goToTrain(mnemonic);
    } else {
      this.goToTerminal(mnemonic);
    }
  }

  /**
   * @memberof QueryViewLocoDataComponent
   */
  ngOnDestroy() {
    this.loadDataToShow = [];
  }

  /**
   * route to respective train
   * @param {any} TrainMnemonic
   * @memberof QueryViewLocoDataComponent
   */
  goToTrain(TrainMnemonic) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: TrainMnemonic });
    window.open(
      window.location.href.split('?')[0] + '?type=train&subtype=data&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
   * this method check that is ContextMenuAvailable or not
   * @private
   * @param {LocoDetail} locomotive
   * @returns
   *
   * @memberOf LmsTerminalBoundComponent
   */
  private isContextMenuAvailable(locomotive: LocoDetail) {
    if (locomotive && locomotive.locomotiveIdentifier) {
      if (locomotive.locomotiveIdentifier.toUpperCase() === 'ZZZZZZZZZZZZZZ') {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  ngOnInit() {
    this.prepareHeightForPage();
  }

  /**
   * route acc. to condition
   * @param {string} subType
   * @param {string} type
   * @param {string} searchText
   * @memberof QueryViewLocoDataComponent
   */
  public routeToPage(subType: string, type: string, searchText: string) {
    

    if (subType !== 'Locate') {
      // Story #6 - Code to open Train Data in new window
      const tabSearchParameter = <TabSearchParameter>({ searchText: searchText });
      window.open(
        window.location.href.split('?')[0] + '?type='+ type.toLowerCase() +'&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
          '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
        );
      
    } else {
      const yLData = {
        div: this.overlayLocateLocoData.allocDivision,
        allocStation: this.overlayLocateLocoData.allocStation,
        allocType: this.overlayLocateLocoData.allocType,
        locomotiveId: this.overlayLocateLocoData.locomotiveId,
      };
      if (this.overlayLocateLocoData && this.overlayLocateLocoData.allocStation.trim().length > 0) {
        this.redirectToYardAndLocal(this.overlayLocateLocoData.allocDivision, this.overlayLocateLocoData.allocStation, this.overlayLocateLocoData.allocType);
      } else {
        if ('MW' === this.overlayLocateLocoData.permTag.toUpperCase().trim() && 0 === this.overlayLocateLocoData.allocStation.trim().length) {
          this.redirectToYardAndLocal('ALLMOW', 'all', 'M');
        } else {
          if ('I' === this.overlayLocateLocoData.qualCode.toUpperCase()
            || 'E' === this.overlayLocateLocoData.qualCode.toUpperCase() || 'O' === this.overlayLocateLocoData.qualCode.toUpperCase()) {
            this.appUtilService.locate('train', 'data', this.overlayLocateLocoData.lmsLocation, this.appUtilityService.UIformatLocomotiveId(this.overlayLocateLocoData.locomotiveId));
          } else if ('S' === this.overlayLocateLocoData.qualCode.toUpperCase()
            || 'W' === this.overlayLocateLocoData.qualCode.toUpperCase() || 'Y' === this.overlayLocateLocoData.qualCode.toUpperCase()) {
             this.appUtilityService.navigateByUrl('locomotive', 'data', this.appUtilityService.UIformatLocomotiveId(this.overlayLocateLocoData.locomotiveId), true);
            // const tabSearchParameter = <TabSearchParameter>({ searchText: this.appUtilityService.UIformatLocomotiveId(this.overlayLocateLocoData.locomotiveId) });
            // window.open(
            //   window.location.href.split('?')[0] + '?type=locomotive&subtype=data&search=' + tabSearchParameter.searchText,
            //     '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
            //   );
          } else if ('V' === this.overlayLocateLocoData.qualCode.toUpperCase()) {
            this.redirectToYardAndLocal(this.overlayLocateLocoData.currentAssignment, 'all', 'A');
          } else {
             this.appUtilService.locate('terminal', 'status', this.overlayLocateLocoData.lmsLocation, this.appUtilityService.UIformatLocomotiveId(this.overlayLocateLocoData.locomotiveId));
            // const tabSearchParameter = <TabSearchParameter>({ searchText: this.overlayLocateLocoData.lmsLocation });
            // window.open(
            //   window.location.href.split('?')[0] + '?type=terminal&subtype=status&search=' + tabSearchParameter.searchText,
            //     '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
            //   );
          }
        }
      }
    }
  }

  /**
  * Redirect to yard and local screen.
  * @memberof QueryViewLocoDataComponent
  */
  redirectToYardAndLocal(division?: string, allocationStation?: string, allocationType?: string) {
    if (this.overlayLocateLocoData) {
      if (this.tabService.isTabRedirectionAllowed('yard-local', 'data')) {
        const yarLocalRouteParams = `division=${division}&allocationStation=${allocationStation}&allocationType=${allocationType}&locomotiveId=${this.overlayLocateLocoData.locomotiveId}`;
        this.router.navigateByUrl(`/yard-local/data/${new Date().getTime()}?${yarLocalRouteParams}`,
          { skipLocationChange: environment.hideUrl });
      } else {
        this.messageHandlerService.handleMessage(<MessageDetails>({
          type: this.configService.getConfigData().message.type.client,
          level: this.configService.getConfigData().message.level.error,
          target: this.configService.getConfigData().message.target.page,
          message: this.configService.getConfigData().messages.maxTab
        }));
      }
    }
  }

  /**
   * trigger download excel service
   * @memberof QueryViewLocoDataComponent
   */
  downloadLocoExcel() {
    const dataToExport = this.locoDataTable.filteredValue === undefined || this.locoDataTable.filteredValue === null ? this.loadData.data : this.locoDataTable.filteredValue;
    for(let i=0;i<dataToExport.length;i++) {
      let item = dataToExport[i];
      item.oprtngRegion = item.oprtngRegionName;
      item.oprtngZone = item.oprtngZoneName;
    }
    this.queryViewService.excelLocoDownload(dataToExport);
  }

  /**
   * set page height when page size changes
   * @param {*} directiveElement
   * @returns
   * @memberof QueryViewLocoDataComponent
   */
  setHeight(directiveElement: any) {
    const heightArray = [];
    let lastVal = 0;
    const childElements = directiveElement.querySelectorAll(`tr`);
    const childElementsLength = childElements.length;
    for (let i = 0; i < childElementsLength; i++) {
      lastVal += childElements[i].getBoundingClientRect().height;
      heightArray.push(lastVal);
    }
    return heightArray;
  }
}
